import { action } from 'typesafe-actions'
import { Subscription, SubscriptionTypes } from './types'

export const getSubscriptionsOnce = () => action(SubscriptionTypes.GET_SUBSCRIPTIONS_ONCE)

export const fetchSubscriptions = {
  request: () => action(SubscriptionTypes.FETCH_SUBSCRIPTIONS_REQUEST),

  success: (payload: { subscriptions: Subscription[] }) =>
    action(SubscriptionTypes.FETCH_SUBSCRIPTIONS_SUCCESS, payload),

  failure: (error: any) => action(SubscriptionTypes.FETCH_SUBSCRIPTIONS_FAILURE, error),
}
